export function parseDelimitedHierarchy(str) {
  if (!str) return [];
  const segments = str
    .split(',')
    .map((segment) => segment.trim())
    .filter(Boolean);
  if (!segments.length) return [];

  return segments
    .map((segment, idx) => {
      const [rawKey, ...rest] = segment.split(':');
      if (rest.length) {
        return [(rawKey || '').trim() || `Level ${idx + 1}`, rest.join(':').trim()];
      }
      const value = (rawKey || '').trim();
      if (!value) return null;
      return [`Level ${idx + 1}`, value];
    })
    .filter(Boolean);
}

export function normalizeTaxonomyHierarchyEntries(hierarchy) {
  if (!hierarchy) return [];

  if (typeof hierarchy === 'string') {
    const trimmed = hierarchy.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed && typeof parsed === 'object') {
        return Object.entries(parsed).filter(([, value]) => value != null && `${value}`.trim() !== '');
      }
    } catch (err) {
      // Fallback to delimited parsing
    }
    const delimited = parseDelimitedHierarchy(trimmed);
    if (delimited.length) {
      return delimited;
    }
    return [['classification', trimmed]];
  }

  if (Array.isArray(hierarchy)) {
    return hierarchy
      .map((entry, idx) => {
        if (Array.isArray(entry) && entry.length >= 2) {
          return [entry[0], entry[1]];
        }
        if (entry && typeof entry === 'object') {
          // Best-practice: { rank, value } pairs
          if ('rank' in entry && 'value' in entry) {
            const k = entry.rank;
            const v = entry.value;
            if (k == null || `${k}`.trim() === '') return null;
            if (v == null || `${v}`.trim() === '') return null;
            return [k, v];
          }
          const key = Object.keys(entry)[0];
          return key ? [key, entry[key]] : null;
        }
        if (entry == null) return null;
        return [`Level ${idx + 1}`, String(entry)];
      })
      .filter(Boolean)
      .filter(([, value]) => value != null && `${value}`.trim() !== '');
  }

  if (typeof hierarchy === 'object') {
    return Object.entries(hierarchy).filter(([, value]) => value != null && `${value}`.trim() !== '');
  }

  return [];
}

